module.exports = __webpack_public_path__ + "img/white-cam-2.108a24bc.png";